enum NavigationSizes {
  Regular = 0,
  Small = 1,
  Large = 2,
}

export default NavigationSizes;
